<template>
  <v-container >
    <h1 class="gallery-category-title">{{ categoryName }}</h1>
    <v-row justify="center">
      <v-btn text
             :absolute="!$vuetify.breakpoint.xsOnly"
             :block="$vuetify.breakpoint.xsOnly"
             width="fit-content"
             center
             small
             @click="$router.push('/gallery')"
      >
        Torna alla galleria
      </v-btn>
    </v-row>


    <v-row align="stretch"  class="mt-10">
      <v-col v-for="(album, index) in albums" :key="album.key" cols="12" md="6"
             class="d-flex align-stretch py-4 px-4 album img-hover-zoom" @click="showSubcategory(index)">
        <v-row>
          <v-col sm="4" class="image-container">
              <v-img :src="album.thumbnail" aspect-ratio="1" class="thumbnail"
              />
          </v-col>

          <v-col sm="8" class="d-flex flex-column justify-center album-info">
            <h3 :class="$vuetify.breakpoint.xsOnly ? 'album-title-mobile' : 'album-title'">{{ album.title }}</h3>
            <p :class="$vuetify.breakpoint.xsOnly ? 'album-desc-mobile' : 'album-desc'">{{album.desc}}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-overlay v-if="displayCarousel">
        <v-window v-model="slideshowIndex" show-arrows touchless continuous v-click-outside="closeSubcategory">
          <v-window-item
                        v-for="pic in items"
                        :key="pic"
          >
            <v-sheet
                tile
                width="85vw"
                height="85vh"
                class="d-flex justify-center align-center"
            >
              <v-img :src="pic" max-height="85vh" max-width="85vw" contain class="image" />

            </v-sheet>

          </v-window-item>
          <v-btn icon absolute :class="{'close-carousel-desktop': $vuetify.breakpoint.smAndUp, 'close-carousel-mobile': $vuetify.breakpoint.xsOnly}" @click="closeSubcategory">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-window>
    </v-overlay>


    <v-row justify="center" >
      <v-btn icon x-large @click="scrollTop">
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-row>

  </v-container>
</template>


<script>


export default {
  name: "GalleryCategory",
  data() {
    return {
      galleryContent: [],
      openSubcategory: null,
      slideshowIndex: null,
      displayCarousel: false
    }
  },
  computed: {
    selected() {
      return this.$route.params.category
    },
    categoryName() {
      switch (this.selected) {
        case 'decori-interni':
          return 'Decorazioni interni'
        case 'decori-esterni':
          return 'Decorazioni esterni'
        case 'restauri-interni':
          return 'Restauri interni'
        case 'restauri-esterni':
          return 'Restauri esterni'
        default:
            return ''
      }
    },
    items() {
      if (this.openSubcategory === null)
        return []
      return this.albums[this.openSubcategory].content
    },
    gallery() {
      return this.$store.state.gallery
    },
    albums() {
      return this.gallery[this.selected]
    }
  },
  methods: {
    showSubcategory(index) {
      this.displayCarousel = true
      this.openSubcategory = index
      this.slideshowIndex = 0
    },
    closeSubcategory() {
      this.displayCarousel = false
      this.openSubcategory = null
      this.slideshowIndex = 0
    },
    scrollTop() {
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
  }
}
</script>

<style scoped>

.thumbnail {
  cursor: pointer;
  background: transparent url('../../public/loading_black.gif') center no-repeat;
  overflow: hidden;
}


.gallery-category-title {
  font-family: 'Itim', cursive;
  text-align: center;
}

/* [2] Transition property for smooth transformation of images */
.img-hover-zoom .thumbnail {
  transition: transform 1s ease;
}

/* [3] Finally, transforming the image when container gets hovered */
.img-hover-zoom:hover .thumbnail {
  transform: scale(1.3);
}

.album {
  cursor: pointer;
}

.album-info {
  font-family: 'Urbanist', sans-serif;
}

.album-title {
  font-size: 1.2rem;
}

.album-desc {
  font-size: 1rem;
}

.album-title-mobile {
  font-size: 1rem;
}

.album-desc-mobile {
  font-size: .9rem;
}


.image-container {
  overflow: hidden;
}

.back-btn-row {
  position: absolute;
  top: 200px;
}

.close-carousel-desktop {
  top: 20px;
  right: 20px;
}

.close-carousel-mobile {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
}

.image {
  background: transparent url('../../public/loading.gif') center no-repeat;
}
</style>